import { useQuery } from "@tanstack/react-query";

import { getSubscriptionStatus } from "../api/subscriptionApi";

/**
 * Hook to fetch and manage subscription status
 * Automatically enables polling when there's a pending request
 */
export const useSubscriptionStatus = (options = {}) => {
  const query = useQuery({
    queryKey: ["subscription", "status"],
    queryFn: getSubscriptionStatus,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: (data) => {
      // Auto-enable polling if there's a pending request
      const isPendingActive = [
        "pending",
        "payment_details_sent",
        "payment_received",
      ].includes(data?.pendingRequest?.status);
      
      return isPendingActive ? 30000 : false; // 30 seconds
    },
    refetchIntervalInBackground: false,
    ...options,
  });

  return query;
};
